import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../shared/translation.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OeAppService } from '../shared/oe-app.service';
import { GAME_RULES_SUPPORTED_LANGUAGES, Language } from '../shared/types/language';
import { WindowService } from '../shared/window.service';

@Component({
  selector: 'lp2-game-rules',
  templateUrl: './game-rules.component.html',
  styleUrls: ['./game-rules.component.scss'],
})
export class GameRulesComponent implements OnInit {
  iframeUrl: SafeResourceUrl;

  constructor(
    private readonly translationService: TranslationService,
    private sanitizer: DomSanitizer,
    private oeApp: OeAppService,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    const urlParams = new URLSearchParams(this.windowService.nativeWindow().location.search);
    const htmlPage = this.getUrl(urlParams.get('section'));

    const language = this.setContentLanguage(this.translationService.getCurrentLanguage());

    const iframeStr = `${this.oeApp.gamificationGameRulesUrl()}/${language.toUpperCase()}/${htmlPage}`;

    if (iframeStr) {
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeStr);
    }
  }

  private getUrl(section: string) {
    let htmlPage = 'index.html';
    switch (section) {
      case 'intro':
        htmlPage = 'intro.html';
        break;
      case 'badges':
        htmlPage += '#badges';
        break;
      case 'leagues':
        htmlPage += '#leagues';
        break;
      case 'miles-4':
        htmlPage += '#miles-4';
        break;
    }

    return htmlPage;
  }

  private setContentLanguage(lang: string) {
    if (GAME_RULES_SUPPORTED_LANGUAGES.find((l) => l === lang)) {
      return lang;
    }

    return Language.ENGLISH;
  }
}



// WEBPACK FOOTER //
// ./ts/app/game-rules/game-rules.component.ts